class Labels {
  constructor() {
    this.formName = '';
  }

  formName: string;

  [key: string]: string;
}

export default Labels;
